import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DocxSvg = function DocxSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5c0 .137.112.25.25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.78 6.427 17.073 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75h14.5a.75.75 0 0 0 .75-.75V6.957c0-.2-.078-.388-.22-.53M17 2.354 21.147 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M19.75 15H14v.5h5.75a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M19.75 13.5H14v.5h5.75a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M19.75 12H14v.5h5.75a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M19.75 10.5H14v.5h5.75a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    d: "M5.915 14.661q.024.196.032.342h.019q.033-.335.107-.664L6.96 10.5h1.148l.918 3.782q.069.28.115.713h.015q.02-.3.095-.69l.736-3.805h1.043L9.747 16H8.525l-.876-3.643a8 8 0 0 1-.146-.78H7.49q-.015.135-.06.4-.045.264-.07.391L6.536 16h-1.24L4 10.5h1.064l.798 3.847q.026.12.053.314"
  }));
};
export var Docx = function Docx(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DocxSvg
  }));
};